module.exports = __webpack_public_path__ + "ec5c38f29ed3715e0179e1329bd1c9f5.png";